import { useGetList } from 'react-admin';
import { useEffect } from 'react';
import { Vehicle } from '@/interface/entityInterface';

const useVehicles = () => {
    const { data = [], total, isLoading, error, refetch } = useGetList<Vehicle>(
        'gps-track/track-vehicles-status',
        {
            pagination: { page: 1, perPage: 23 },
            sort: { field: 'date', order: 'DESC' },
            filter: {},
        }
    );

    // Auto-refetch every 10 seconds
    useEffect(() => {
        const interval = setInterval(() => {
            refetch();
        }, 5000); // 5 seconds  // Too much ??

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, [refetch]);

    return { data, total, isLoading, error, refetch };
};

export default useVehicles;